/* Product features tabs: instant panel swap (no animation), full keyboard
   support (arrow keys, Home/End, click). Scoped per .up-features instance. */
(function () {
  function init(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-up-features-tab]'));
    if (!tabs.length) return;

    function selectTab(index, focus) {
      tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;

        var panel = root.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = !selected;
        }
      });
      if (focus) tabs[index].focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        selectTab(index, false);
      });

      tab.addEventListener('keydown', function (event) {
        var newIndex = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            newIndex = (index + 1) % tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            newIndex = (index - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            newIndex = 0;
            break;
          case 'End':
            newIndex = tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        selectTab(newIndex, true);
      });
    });
  }

  document.querySelectorAll('.up-features').forEach(init);
})();
